import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { PostalAddress } from '../../model/postal-address';

const formControls = {
  additionalName: 'additionalName',
  name: 'name',
};

@Component({
  selector: 'app-postal-address',
  templateUrl: './postal-address.component.html',
  styleUrls: ['./postal-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostalAddressComponent implements OnChanges, OnInit {
  constructor(private _fcf: FormControlExFactory) {
    this.title = 'ADDRESS_FORM.HEADER';
  }

  private _group: AbstractControl;
  @Input() set group(value: AbstractControl) {
    this._group = value;
  }
  get group(): FormGroup {
    return this._group as FormGroup;
  }
  @Input() helpText: string;
  @Input() mandatory: boolean;
  @Input() model: PostalAddress;
  @Input() nameLabel: string;
  @Input() showName: boolean;
  @Input() title: string;
  @Input() countryColumnSpan = 1;

  initialized: boolean;

  private _getNameLabel(): string {
    return this.nameLabel ? this.nameLabel : 'ADDRESS_FORM.NAME_LABEL';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && !changes['model'].firstChange) {
      this.group.controls[formControls.additionalName].setValue(this.model.additionalName);

      if (this.showName) this.group.controls[formControls.name].setValue(this.model.name);
    }
  }

  ngOnInit() {
    if (this.showName) {
      this.group.addControl(
        formControls.additionalName,
        this._fcf.createMaxLength('ADDRESS_FORM.ADDRESS_ROW2', this.model.additionalName, 50)
      );
      this.group.addControl(
        formControls.name,
        this._fcf.createWithOptions(this._getNameLabel(), this.model.name, { required: this.mandatory, length: 100 })
      );
    } else {
      this.group.addControl(
        formControls.additionalName,
        this._fcf.createMaxLength('ADDRESS_FORM.RECIPIENT_LABEL', this.model.additionalName, 50)
      );
    }
  }
}
